export {
  SearchPageContext,
  SearchPageProvider,
  useSearchPageContext,
} from "./SearchPageProvider";
